import { paginationElementClassName } from './index';

export const swiperSettings = (language: string) => {
    return {
        swiperSettings: {
            autoplay: false,
            freeMode: false,
            loop: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            breakpoints: {
                560: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
            },
            dir: language === 'ar' ? 'rtl' : 'ltr',
            pagination: {
                el: `.${paginationElementClassName}`,
                clickable: true,
            },
        },
    };
};
